import { render, staticRenderFns } from "./SupsisButton.vue?vue&type=template&id=4370a2a5&scoped=true"
import script from "./SupsisButton.vue?vue&type=script&lang=js"
export * from "./SupsisButton.vue?vue&type=script&lang=js"
import style0 from "./SupsisButton.vue?vue&type=style&index=0&id=4370a2a5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4370a2a5",
  null
  
)

export default component.exports